import React from 'react'

const Spinner = () => (
    <div className="shtum--page-center-wide">
        <svg className="shtum--svg shtum--svg-5x shtum--svg-spin shtum--svg_green">
            <use xlinkHref="#icon-loader-2"></use>
        </svg>
    </div>
);

export default Spinner;
